<template>
  <v-chip
    v-if="email.classification"
    class="text-uppercase"
    color="secondary"
    density="comfortable"
    label
    title="Email classification"
  >
    <v-icon icon="mdi-information-outline" start />
    {{ email.classification.replaceAll('_', ' ') }}
  </v-chip>
</template>

<script setup lang="ts">
export interface Props {
  email: any
}

defineProps<Props>()
</script>
